import './styles.scss';

import React, {useMemo} from 'react';

import {HeaderDashboardIcon, HeaderNotificationIcon} from '../../../../../constants/Icons';

export enum HeaderItemLinkMode {
    DASHBOARD = 'Dashboard',
    NOTIFICATION = 'Notifications',
}

interface HeaderItemLinkProps {
    mode: HeaderItemLinkMode;
    onClick: () => void;
}

export const HeaderItemLink = ({mode, onClick}: HeaderItemLinkProps) => {
    const icon = useMemo(() => {
        switch (mode) {
            case HeaderItemLinkMode.DASHBOARD:
                return <HeaderDashboardIcon />;
            case HeaderItemLinkMode.NOTIFICATION:
                return <HeaderNotificationIcon />;
            default:
                return null;
        }
    }, [mode]);

    return (
        <div className='header-item-link' onClick={onClick}>
            {icon}
            <div className='header-item-link__text'>{mode}</div>
        </div>
    );
};
